import React, { useState } from 'react';
import styled from 'styled-components';
import { mediaBreakpointDown } from '../../utils/styling';
import Menu from '../../images/menu.inline.svg';
import Link from '../Link';
import { navigate } from "gatsby"

const HeaderContainer = styled.header`
	${mediaBreakpointDown('md')} {
		background-color: #f0f5f8;
		background: rgba(240, 245, 248, 0.8);
	}
`;
const HeaderContent = styled.div`
	padding: 30px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	position: relative;
	max-width: 1500px;
	margin: 0 auto;
	@media (max-width: 1500px) {
		justify-content: right;
	}
`;
const Logo = styled.div`
	position: absolute;
	left: 30px;
	> a {
		color: #232e69;
		font-size: 25px;
		font-weight: 700;
	}

	${mediaBreakpointDown('md')} {
		min-width: 300px;
		min-height: 41px;
		min-width: > a {
			min-height: 40px;
		}
	}

	${mediaBreakpointDown('xs')} {
		left: 20px;
	}
`;
const NavigationList = styled.ul`
	display: flex;
	margin: 0;
	padding: 0;
	@media (max-width: 1400px) {
		margin: 0 0 0 180px;
	}
	@media (max-width: 1150px) {
		margin: 0 0 0 140px !important;
	}
	${mediaBreakpointDown('lg')} {
		margin: 0 0 0 180px;
	}
	${mediaBreakpointDown('md')} {
		display: none;
	
`;
const NavigationItem = styled.li`
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	list-style: none;
	margin-right: 20px;
	:last-child {
		margin-right: 0;
	}
	> a {
		color: rgba(50, 58, 86, 0.8);
		font-size: 13px;
		text-transform: uppercase;
		font-weight: 700;
		padding: 0;
		display: block;
		transition: all 0.3s ease-in-out 0s;
	}
	@media (max-width: 1200px) {
		line-height: 14px;
		margin-right: 8px;
	}
`;
const MenuIcon = styled.button`
	position: absolute;
	right: 30px;
	display: none;
	padding: 0;
	background: transparent;
	align-items: center;
	justify-content: center;

	${mediaBreakpointDown('md')} {
		display: flex;
	}
	${mediaBreakpointDown('xs')} {
		right: 20px;
	}
`;
const MenuListContent = styled.div`
	display: ${(props) => (props.visible ? 'flex' : 'none')};
	padding: 0 0 20px 0;
	display: flex;
	flex-direction: column;
	justify-content: start;
`;
const MenuList = styled.div`
	max-height: 0;
	overflow: hidden;
	background-color: transparent;

	transition: max-height 1s ease-in-out;
	padding: 0 20px;

	${(props) =>
		props.visible &&
		`
		transition: max-height 1s ease-in-out;
		max-height: 575px;
	`}
`;
const MenuItem = styled.div`
	border-bottom: 1px solid #ced8e1;

	:last-child {
		border-bottom: none;
	}
	> a {
		color: rgba(50, 58, 86, 0.8);
		font-size: 13px;
		text-transform: uppercase;
		font-weight: 600;
		padding: 13px 0;
		display: block;
		transition: all 0.3s ease-in-out 0s;
	}
`;

const TopFeaturesMenuItem = styled.div`
	border-bottom: 1px solid #ced8e1;

	:last-child {
		border-bottom: none;
	}
	> a {
		color: #e01efe;
		font-size: 13px;
		text-transform: uppercase;
		font-weight: 600;
		padding: 13px 0;
		display: block;
		transition: all 0.3s ease-in-out 0s;
		opacity: 0.6;
	}
`;

const TopFeaturesNavigationItem = styled.li`
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	list-style: none;
	margin-right: 20px;
	:last-child {
		margin-right: 0;
	}
	> a {
		color: #e01efee8;
		font-size: 13px;
		text-transform: uppercase;
		font-weight: 700;
		padding: 0;
		display: block;
		transition: all 0.3s ease-in-out 0s;
	}
	@media (max-width: 1200px) {
		line-height: 14px;
		margin-right: 8px;
	}
`;

const SignInLink = styled.button`
	background-color: transparent;
	background-repeat: no-repeat;
	border: none;
	cursor: pointer;
	overflow: hidden;
	outline: none;
	font-weight: inherit;
	color: rgba(50, 58, 86, 0.8);
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 0;
	display: block;
	transition: all 0.3s ease-in-out 0s;
`;

const SignUpLinkMobile = styled.button`
	background-color: transparent;
	background-repeat: no-repeat;
	border: none;
	cursor: pointer;
	overflow: hidden;
	outline: none;
	font-weight: inherit;
	color: rgba(50, 58, 86, 0.8);
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 600;
	padding: 13px 0;
	display: block;
	transition: all 0.3s ease-in-out 0s;
	text-align: left;
`




function Header({ dnpUrl }) {
	const [visible, setVisible] = useState(false);

	const HEADERS = [
		{
			label: 'Learn',
			url: '/',
		},
		{
			label: 'Burner Phones',
			url: '/burner-phones/',
		},
		{
			label: 'Warranty',
			responsiveLabel: "Claim a Warranty",
			url: '/claim-a-warranty/',
		},
		{
			label: 'Free Trials',
			responsiveLabel: "Get Free Trials",
			url: '/free-trials/',
		},
		{
			label: 'How To Cancel',
			responsiveLabel: "Cancel Any Service",
			url: '/how-to-cancel/',
		},
		{
			label: 'Refunds',
			responsiveLabel: "Chargebacks & Refunds",
			url: '/chargebacks-and-refunds/',
		},
		{
			label: 'Unban Account',
			responsiveLabel: "Appeal Banned Account",
			url: '/appeal-banned-account/',
		},
		{
			label: 'Top Features',
			url: '/most-popular-features/',
		},
		{
			label: 'Latest',
			url: '/most-recent-resources/',
		},
	];

	const handleLoginRedirect = () => {
		const navigateTo = dnpUrl || "https://donotpay.com/login/";
		window.location.href = navigateTo;
		// navigate(navigateTo)
	}

	return (
		<HeaderContainer>
			<HeaderContent>
				<Logo>
					<Link to="https://donotpay.com/">DoNotPay</Link>
				</Logo>
				<NavigationList>
					{HEADERS.map((item) => {
						return item.label === 'Top Features' || item.label === 'Latest' ? (
							<TopFeaturesNavigationItem
								key={item.url}
							>
								<Link noPrefetch to={item.url}>
									{item.label}
								</Link>
							</TopFeaturesNavigationItem>
						) : (
							<NavigationItem
								key={item.url}
							>
								<Link noPrefetch to={item.url}>
									{item.label}
								</Link>
							</NavigationItem>
						);
					})}

					{/* <TopFeaturesNavigationItem
						key="business"
					>
						<a href="https://donotpay.com/business/">
							Business
						</a>
					</TopFeaturesNavigationItem> */}

					<TopFeaturesNavigationItem
						key="about"
					>
						<a href="https://donotpay.com/about/">
							About
						</a>
					</TopFeaturesNavigationItem>

					<SignInLink
						onClick={handleLoginRedirect}
					>SIGN UP/SIGN IN</SignInLink>
				</NavigationList>
				<MenuIcon aria-label="Menu Options" onClick={() => setVisible(!visible)}>
					<Menu />
				</MenuIcon>
			</HeaderContent>
			<MenuList visible={visible}>
				<MenuListContent visible={visible}>
					{HEADERS.map((item) => {
						return item.label === 'Top Features' || item.label === 'Latest' ? (
							<TopFeaturesMenuItem
								key={item.url}
							>
								<Link to={item.url}>{item.label}</Link>
							</TopFeaturesMenuItem>
						) : (
							<MenuItem
								key={item.url}
							>
								{item.responsiveLabel ?
									<Link noPrefetch to={item.url}>
										{item.responsiveLabel}
									</Link> :
									<Link to={item.url}>{item.label}</Link>
								}
							</MenuItem>
						);
					})}
					{/* <TopFeaturesMenuItem
						key="business"
					>
						<a href={"https://donotpay.com/business/"}>Business</a>
					</TopFeaturesMenuItem> */}
					<TopFeaturesMenuItem
						key="about"
					>
						<a href={"https://donotpay.com/about/"}>About</a>
					</TopFeaturesMenuItem>
					<SignUpLinkMobile onClick={handleLoginRedirect}>SIGN UP/SIGN IN</SignUpLinkMobile>
				</MenuListContent>
			</MenuList>
		</HeaderContainer>
	);
}

export default React.memo(Header);
